var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-card", staticStyle: { "min-height": "6.6rem" } },
    [
      _c("div", { staticClass: "spaceLeft" }, [
        _c("div", { staticClass: "detail-title-1" }, [
          _vm._v("Bid number : " + _vm._s(_vm.pageData.number)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "status",
            class: {
              "status-ing": _vm.pageData.status != 3,
              "status-over": _vm.isOver(_vm.pageData.overtime),
            },
          },
          [
            _vm._v(
              _vm._s(
                _vm.statusMap[
                  "status_" +
                    (_vm.isOver(_vm.pageData.overtime)
                      ? "3"
                      : _vm.pageData.status)
                ]
              )
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 11, lg: 11 } }, [
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Starting time:"),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm
                      .moment(_vm.pageData.timestamp)
                      .utc()
                      .format("YYYY-MM-DD HH:mm:ss")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Closing time:"),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm
                      .moment(_vm.pageData.overtime)
                      .utc()
                      .format("YYYY-MM-DD HH:mm:ss")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "detail-item spaceLeft" },
              [
                _c("span", { staticClass: "detail-item-label" }, [
                  _vm._v("Auction:"),
                ]),
                _vm._v(" "),
                _c("big-number", { attrs: { number: _vm.pageData.amount } }),
                _vm._v(" "),
                _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "detail-item spaceLeft" },
              [
                _c("span", { staticClass: "detail-item-label" }, [
                  _vm._v("Reserve price:"),
                ]),
                _vm._v(" "),
                _c("big-number", {
                  attrs: { number: _vm.pageData.startAmount },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 13, lg: 13 } },
            [
              _c("place-bid-time", {
                attrs: { hasBid: _vm.hasBid, closeTime: _vm.pageData.overtime },
                on: {
                  "update:hasBid": function ($event) {
                    _vm.hasBid = $event
                  },
                  "update:has-bid": function ($event) {
                    _vm.hasBid = $event
                  },
                  "update:closeTime": function ($event) {
                    return _vm.$set(_vm.pageData, "overtime", $event)
                  },
                  "update:close-time": function ($event) {
                    return _vm.$set(_vm.pageData, "overtime", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "spaceLeft detail-title-2" },
            [
              _vm._v("\n      All Bids\n      "),
              _c(
                "el-button",
                {
                  staticClass: "upper",
                  staticStyle: { "margin-left": "0.2rem" },
                  attrs: { type: "text" },
                  on: { click: _vm.toDetail },
                },
                [
                  _vm._v("more"),
                  _c("i", {
                    staticClass: "el-icon-d-arrow-right",
                    staticStyle: { "margin-left": "0.08rem" },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "data1", label: "", width: "50px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var $index = ref.$index
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.queryParams.total -
                                ((_vm.queryParams.page - 1) *
                                  _vm.queryParams.pageSize +
                                  $index)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "account",
                  label: "Bidder",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("account", { attrs: { value: row.account } })]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "timestamp", label: "Time" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm
                                .moment(row.timestamp)
                                .utc()
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "Bid price",
                  align: "right",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.amount } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }